import { render, staticRenderFns } from "./TrolTooltipWrapper.vue?vue&type=template&id=f1fe0cbe&scoped=true&"
import script from "./TrolTooltipWrapper.vue?vue&type=script&lang=js&"
export * from "./TrolTooltipWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fe0cbe",
  null
  
)

export default component.exports